import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Notification } from '../shared/notification.service';

export interface DialogData {
  notif: Notification
}

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss']
})
export class NotificationDialogComponent {
  notification: Notification;

  constructor(
    private dialogRef: MatDialogRef<NotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    this.notification = data.notif;
  }

  disableNotif($event) {
    let notifStatus = JSON.parse(localStorage.getItem('notification'));
    notifStatus = localStorage.setItem('notification', JSON.stringify({id: this.data.notif.id, enabled: !$event.checked}));
  }
}
